import * as authentication from "../actions/authentication";

import {static as Immutable} from "seamless-immutable";
import {localStorageWritingReducer} from "../util/storage";

const defaultState = () => {
    return Immutable({
        loginForm: {
            original: {},
            changes: []
        },
        loggingIn: false,
        token: undefined,
        tokenValidUntil: undefined,
        signedInAs: undefined,
        refreshing: false,
        languageId: undefined,
        serverName: undefined,
        email: undefined,
        chainType: undefined,
        isAdmin: false,
        isImpersonated: false,
        chainIds: [],
        pickupTobaccoDefault: true,
        freightChargePickupTobacco: null,
        isBlockedCustomer: false,
        webEditOnlyTobacco: false,
        webSiteClosed: false,
        webSiteClosedMessage: "",
        userConfirmedWebSiteClosedMessage: false,
        newSeasonDistrDates: [],
        showFreshFood: false,
    });
};

const reducer = (state = defaultState(), action) => {
    switch (action.type) {
    case authentication.LOGGING_IN:
        return Immutable.set(state, "loggingIn", true);
    case authentication.LOGIN_ATTEMPT_ENDED:
        return Immutable.set(state, "loggingIn", false);
    case authentication.LOGGED_IN:       
        return Immutable.merge(state, {
            loggingIn: false,
            token: action.token,
            refreshToken: action.refreshToken,
            tokenValidUntil: action.tokenValidUntil,
            signedInAs: action.signedInAs,
            languageId: action.languageId,
            serverName: action.serverName,
            email: action.email,
            isChainLogin:action.isChainLogin,
            isHubLogin:action.isHubLogin,
            isDominosLogin:action.isDominosLogin,
            hubId:action.hubId,
            chainType: action.chainType,
            loginForm: defaultState().loginForm,
            isAdmin: action.isAdmin,
            isImpersonated: action.isImpersonated,
            chainIds: action.chainIds,
            pickupTobaccoDefault: action.pickupTobaccoDefault,
            freightChargePickupTobacco: action.freightChargePickupTobacco,
            isBlockedCustomer: action.isBlockedCustomer,
            webEditOnlyTobacco: action.webEditOnlyTobacco,
            webSiteClosed : false,
            webSiteClosedMessage : "", 
            userConfirmedWebSiteClosedMessage: false,
            newSeasonDistrDates : action.newSeasonDistrDates,
            seasonMessageConfirmed : false,
            showFreshFood : action.showFreshFood,
        });
    case authentication.REFRESHING_TOKEN:
        return Immutable.merge(state, {
            refreshing: true
        });
    case authentication.REFRESHED_TOKEN:
        return Immutable.merge(state, {
            refreshing: false,
            token: action.token,
            refreshToken: action.refreshToken,
            tokenValidUntil: action.tokenValidUntil
        });
    case authentication.FAILED_TO_REFRESH_TOKEN:
        return Immutable.merge(state, {
            refreshing: false
        });
    case authentication.LOGGED_OUT:
        return defaultState();
    case authentication.SET_WEBSITE_STATUS_RESULTS:
        return Immutable.merge(state, {
            webSiteClosed: action.webIsClosed,
            webSiteClosedMessage: action.message,
        });
    case authentication.SET_WEBSITE_MESSAGE_CONFIRMED:
        return Immutable.merge(state, {
            userConfirmedWebSiteClosedMessage: true,
        });
    case authentication.SET_SEASON_MESSAGE_CONFIRMED:
        return Immutable.merge(state, {
            seasonMessageConfirmed : true
        });
    default:
        return state;
    }
};

export default localStorageWritingReducer(reducer, defaultState, "app_authentication", 
    ["token", "refreshToken", "tokenValidUntil", "serverName", "signedInAs", "languageId", "email", "isChainLogin", "isHubLogin", "isDominosLogin", 
        "hubId", "chainType", "isAdmin", "isImpersonate", "chainIds", "pickupTobaccoDefault", "freightChargePickupTobacco", 
        "isBlockedCustomer","webEditOnlyTobacco", "webSiteClosed", "webSiteClosedMessage", "userConfirmedWebSiteClosedMessage", "newSeasonDistrDates", "seasonMessageConfirmed", "showFreshFood"]);

